var numeral = require('numeral')

const number = {
  toNumber(val) {
    return numeral(val)
  },
  //
  formatStr(val, format = '0,0.00') {
    return numeral(val).format(format)
  },
  add(val1, val2) {
    // 加 +
    var number1 = numeral(val1)
    var number2 = numeral(val2)
    return number1.add(number2.value()).value()
  },
  subtract(val1, val2) {
    // 减 -
    var number1 = numeral(val1)
    var number2 = numeral(val2)
    return number1.subtract(number2.value()).value()
  },
  multiply(val1, val2) {
    // 乘 *
    var number1 = numeral(val1)
    var number2 = numeral(val2)
    return number1.multiply(number2.value()).value()
  },
  divide(val1, val2) {
    // 除 /
    var number1 = numeral(val1)
    var number2 = numeral(val2)
    return number1.divide(number2.value()).value()
  }
}

export default number



// WEBPACK FOOTER //
// ./src/api/number.js